export class OperatorFront {

    operario: string;
    claseOperario: string;
    id: number;
}
